<template>
  <div>
    <div v-if="nojob" class="fb tc cr font-22" style="margin-top:12%;">JOB INEXISTENTE.</div>
    <div v-if="!nojob && job.id && !loader" class="job column">
      <div class="title row-g column-s column-m">
        <div class="t grid-12-s row">JOB <strong>{{ job.id }}</strong></div>
        <div class="grid-11-g grid-12-m row align-center">
          <div class="buttons row col-s g6 g12-m g-12-s ac">

            <!--  DELEGACAO PARCEIRO -->
            <div class="row grid-6 grid-12-s aggregate" v-if="supporters && supporters.length > 0">
              <input v-if="resume" type="text" class="input readonly" v-model="delegateName" readonly />
              <select class="input" v-model="job.id_agregado_doutor" v-if="!job.id_agregado_doutor || !resume">
                <option value="">Delegar ao técnico</option>
                <option v-for="(aggregate, i) of supporters.filter((r) => r.status == 'ativo')" :key="'aggregate' + i"
                  :value="aggregate.id">{{ aggregate.nome }}</option>
              </select>
              <Button layout="green-go" @click="setAggregate()"
                v-if="!resume && job.id_agregado_doutor">Delegar</Button>
              <Button layout="red-go" @click="removeAggregate" v-if="resume">Reassumir</Button>
            </div>

            <Button layout="gold" @click="openNote">
              <i class="fa fa-pen-to-square" /> Anotações </Button>&nbsp;
            <Button layout="gray" @click="openAttendance">
              <img src="../assets/img/list.svg" /> Lista de Atendimentos
            </Button>
            <Button v-if="job.id_tipo_servico && showMaterial" layout="gray" style="margin: 0 6px"
              @click="modalMaterial = { show: true, layout: 'Material', title: 'MATERIAIS', job: job }">
              <i class="fa fa-toolbox" /> Materiais
            </Button>
          </div>
          <ul class="job-status row justify-end grid-6-g grid-7-m hide-s">
            <li :class="job.status === 'Com Doutor' || job.status === 'Doutor orientado' ? 'active' : ''">
              Orientações
            </li>
            <li v-if="job.forma_atendimento != 'remoto'" :class="job.status === 'Doutor em trânsito' ? 'active' : ''">
              Deslocamento
            </li>
            <li :class="job.status === 'Doutor no local' ? 'active' : ''">Check-in</li>
            <li :class="job.status === 'Finalizado' || job.status === 'Falha validação' ? 'active' : ''">
              Encerrar
            </li>
          </ul>
        </div>
      </div>
      <div class="info row label align-center wrap justify-space">
        <div class="grid-6-s grid-2-g">
          Status
          <br />
          <strong>{{ job.status.replace("Doutor", "Supporter") }}</strong>
        </div>
        <div class="grid-6-s grid-1-g">
          Atendimento
          <br />
          <strong>{{ job.forma_atendimento }}</strong>
        </div>
        <div class="grid-6-s grid-2-g">
          Gestor da Demanda
          <br />
          <strong>{{ job.nome_gestor }}</strong>
        </div>
        <div v-if="job.codigo_chamado_cliente" class="grid-6-s grid-1-g">
          Cód. Cliente
          <br />
          <strong>{{ job.codigo_chamado_cliente }}</strong>
        </div>
        <div class="grid-6-s grid-2-g">
          Agendado para
          <br />
          <strong>{{ job.dh_agendamento_cliente | date }}</strong>
        </div>
        <div v-if="job.forma_atendimento != 'remoto'" class="openmap row justify-end-g grid-12-s grid-12-m grid-2-g">
          <Button layout="white-m" @click="openMap">
            <img src="../assets/img/google.svg" alt /> &nbsp; Local de atendimento
          </Button>
        </div>
      </div>
      <div v-if="job.mapa_campos && job.mapa_campos.length" class="info label">
        <div class="sla">Campos adicionais</div>
        <div class="row col-s">
          <div class="adicionais g6 g11-s">
            <h3>Registro</h3>
            <div class="row wp">
              <Campo v-for="m of campos_registro" :key="m.nome" :f="m" :v="job[m.nome]" :read="true" />
            </div>
          </div>
          <div class="adicionais g6 g11-s">
            <h3>Encerramento</h3>
            <div class="row wp">
              <Campo v-for="m of campos_encerramento" :key="m.nome" :f="m" :v="job[m.nome]" :read="true" />
            </div>
          </div>
        </div>
      </div>
      <div class="data column label">
        <div class="sla">SLA Eventos</div>
        <div class="row column-s">
          <div v-if="job.forma_atendimento != 'remoto'" class="grid-2-g grid-3-m">
            Início Deslocamento
            <br />
            <strong>{{ new Date(job.sla_inicio_deslocamento).toLocaleString() }}</strong>
          </div>
          <div class="grid-2-g grid-3-m">
            Check-in
            <br />
            <strong>{{ new Date(job.sla_checkin).toLocaleString() }}</strong>
          </div>
          <div class="grid-2-g grid-3-m">
            Fim Atendimento
            <br />
            <strong>{{ new Date(job.sla_encerramento).toLocaleString() }}</strong>
          </div>
        </div>
      </div>

      <div class="grid-12 column label">
        <div class="row column-s mt">
          <div class="grid-6 grid-12-s column label">
            <label>
              Descrição Problema
              <i class="fa fa-question-circle font-13 tip">
                <div>
                  Descreva em detalhes o seu problema. Não informe aqui dados sensíveis.
                </div>
              </i>
            </label>
            <div class="textarea" v-html="job.problema.replace(/\n/g, '<br />')"></div>
          </div>
          <div class="grid-6 grid-12-s column label" v-if="escopo.length">
            <label>
              Complementos
              <i class="fa fa-question-circle font-13 tip">
                <div>Complementos de escopo.</div>
              </i>
            </label>
            <div class="textarea" v-for="(e, i) of escopo" :key="i"><i style="font-size: 11px">{{ e.criado_em | date }} - {{
              e.nome_criado_por }}:</i><br>{{ e.nota }}</div>
          </div>

          <div class="grid-6 grid-12-s column label">
            <br />
            <label>
              Dados Sensíveis
              <i class="fa fa-question-circle font-13 tip">
                <div>
                  Informe aqui dados sensíveis como contatos, endereços, senhas, nomes,
                  telefones, etc.
                </div>
              </i>
            </label>
            <div class="textarea" v-if="job.dado_sensivel" v-html="job.dado_sensivel.replace(/\n/g, '<br />')"></div>
          </div>
        </div>
      </div>

      <div class="grid-12 column label mt" v-if="job.status === 'Falha validação'">
        <label>Validação Atendimento</label>
        <div class="column row-s grid-12">
          <div class="row column-s valid grid-6-s">
            <div class="grid">Cód. Atendimento</div>
            <div class="grid">Supporter</div>
            <div class="grid">Quando</div>
            <div class="grid">Quem</div>
            <div class="grid">Motivo Falha Validação</div>
          </div>
          <div class="row column-s valid-info grid-6-s">
            <div class="grid">{{ job.id }}</div>
            <div class="grid">{{ job.nome_doutor }}</div>
            <div class="grid">
              {{ new Date(job.dh_validacao).toLocaleString() }}
            </div>
            <div class="grid">{{ job.nome_gestor }}</div>
            <div class="grid">{{ job.motivo_falha_validacao }}</div>
          </div>
        </div>
      </div>

      <Notes :notes="job.notas" />

      <div class="buttons-2 row column-s align-center">
        <div class="grid-4 grid-12-s hide-s">
          <Button layout="white-m-gray" @click="router.back()">
            <i class="fa fa-arrow-left"></i> Voltar
          </Button>
        </div>
        <div class="grid-8 grid-12-s row column-s justify-end justify-around">
          <Button v-if="job.id_orientacao &&
            job.status !== 'Doutor no local' &&
            job.status !== 'Falha validação'
          " :layout="`green-go ${!orientation ? 'white' : ''}`" @click="openOrientation">VER ORIENTAÇÕES</Button>
          <Button v-else :layout="`green-go ${!orientation ? 'white' : ''}`" @click="openOrientationDefault">VER
            ORIENTAÇÕES</Button>
          <Button v-if="job.status === 'Doutor orientado' && job.forma_atendimento != 'remoto'" layout="green-go"
            @click="openDeslocation" :disabled="orientation || buttonLoader" :loader="buttonLoader">INICIAR
            DESLOCAMENTO</Button>
          <Button v-if="job.status === 'Doutor orientado' && job.forma_atendimento == 'remoto'" layout="blue-go"
            @click="openCheckin" :disabled="buttonLoader" :loader="buttonLoader">FAZER CHECK-IN</Button>
          <Button v-if="job.status === 'Doutor em trânsito'" layout="blue-go" :disabled="buttonLoader"
            :loader="buttonLoader" @click="openCheckin">FAZER CHECK-IN</Button>
          <Button v-if="job.status === 'Doutor no local' || job.status === 'Falha validação'"
            layout="blue-go justify-center" @click="openAttach">
            <i class="fa fa-paperclip"></i> ANEXAR ARQUIVO
          </Button>
          <Button v-if="job.status === 'Doutor no local' || job.status === 'Falha validação'" layout="green-go"
            @click="openFinish" :loader="buttonLoader">ENCERRAR TRABALHO</Button>
        </div>
      </div>
      <Modal :modal="modalMaterial" />
      <Modal :modal="modal">
        <gmap-map :center="{ lat: job.latitude, lng: job.longitude }" :zoom="14">
          <gmap-marker :position="{ lat: job.latitude, lng: job.longitude }" :draggable="false"></gmap-marker>
        </gmap-map>
      </Modal>
      <Modal :modal="modalMysupporter">
        <div class="text-center modal-mysupporter">
          <img src="../assets/img/mySupporter.png" />

          <div class="delegate">Para delegar é só selecionar o técnico dentro do Job</div>
          <img src="../assets/img/delegate.png" />
        </div>
      </Modal>
      <Status />
    </div>
    <div v-if="loader" class="job-loader column align-center justify-center">
      <Loader />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Loader from "@/components/Loader";
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button";
import Modal from "@/components/Modal";
import Router from "@/router";
import Notes from "@/components/Notes";
import * as VueGoogleMaps from "vue2-google-maps";
import Status from "@/components/Status.vue";
import Campo from "@/components/Campo.vue";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBb14nrVdCZh_uBI-wGkjjmB0ypHS4YInY",
  },
});

export default {
  name: "job",
  props: {
    id: String,
  },
  components: { Button, Loader, Modal, Notes, Status, Campo },
  data() {
    return {
      nojob: false,
      loader: true,
      buttonLoader: false,
      job: {},
      orientation: true,
      modal: {},
      router: Router,
      supporters: [],
      resume: false,
      escopo: [],
      modalMaterial: {},
      showMaterial: false,
      modalMysupporter: {
        show: false,
        layout: "MySupporters",
        title: "MINHA EQUIPE",
        description: "Agora você pode cadastrar seus técnicos e delegar jobs a eles.",
        count: 2,
      },
      delegateName: "",
    };
  },
  methods: {
    ...mapGetters("job", ["GET_JOB"]),
    ...mapActions("job", [
      "COMPLEMENTO_ESCOPO",
      "SET_CHECKIN",
      "SET_DESLOCATION",
      "SET_AGGREGATE",
      "REMOVE_AGGREGATE",
      "LOAD_JOB",
      "SET_ORIENTATION",
    ]),
    ...mapActions("admin", ["AGGREGATE_SUPPORTER_LIST", "MATERIAL_SERVICETYPE"]),
    setAggregate() {
      if (this.job.id_agregado_doutor) {
        this.SET_AGGREGATE({
          id: this.job.id_agregado_doutor,
          job: this.job.id,
        }).then((r) => {
          if (r.status == 200 || r.status == 201) {
            this.resume = true;
            this.delegateName = this.supporters.filter(
              (r) => r.id == this.job.id_agregado_doutor
            )[0].nome;
          }
        });
      }
    },
    removeAggregate() {
      this.REMOVE_AGGREGATE(this.job.id).then((r) => {
        if (r.status == 200 || r.status == 201) {
          this.resume = false;
          this.job.id_agregado_doutor = "";
        }
      });
    },
    oriented() {
      this.orientation = false;
      this.modal.show = false;
      this.SET_ORIENTATION(this.job.id).then(() => {
        this.job.status = "Doutor orientado";
      });
    },
    update() {
      this.loader = false;
      this.buttonLoader = true;
      this.modal.description += this.job.id;
      this.orientation = this.job.status != "Com Doutor" ? false : true;
      this.modal.callback =
        this.job.status != "Com Doutor" ? () => (this.modal.show = false) : this.oriented;
      this.buttonLoader = false;
    },
    async getJob() {
      this.LOAD_JOB(this.$route.params.id).then((r) => {
        this.job = this.GET_JOB();
        if (r.id) {

          if (this.job.id_tipo_servico) {
            this.MATERIAL_SERVICETYPE({ t: 'get', id: this.job.id_tipo_servico }).
              then(({ data }) => {
                if (data && data.length) this.showMaterial = true
              })

          }
          if (!this.job.id_agregado_doutor) this.job.id_agregado_doutor = "";
          else this.resume = true;
          this.update();

          if (this.user.perfil == "doutor")
            this.AGGREGATE_SUPPORTER_LIST().then((r) => {
              this.supporters = r.data || [];

              if (this.supporters && this.supporters.length && this.job.id_agregado_doutor)
                this.delegateName = this.supporters.filter(
                  (r) => this.job.id_agregado_doutor == r.id
                )[0].nome;

              if (this.user.perfil == "doutor" && this.supporters.length > 0)
                this.modalMysupporter.show = true;
            });


        } else {
          this.nojob = true;
          this.loader=false
        }

      }).catch(() => {
        this.nojob = true;
        this.loader=false
      });
    },
    openMap() {
      this.modal = {
        id: this.id || this.$route.params.id,
        show: true,
        title: "Local de Atendimento",
        description: `${this.job.logradouro}, ${this.job.numero} ${this.job.complemento} - ${this.job.bairro} - ${this.job.cidade}/${this.job.estado}`,
        layout: false,
        map: true,
      };
      /* this.job.status = "Doutor no local"; */
    },
    openNote() {
      this.modal = {
        id: this.id || this.$route.params.id,
        show: true,
        title: "Anotações",
        description: "Job J",
        layout: "Note",
      };
      this.update();
    },
    openOrientation() {
      this.modal = {
        id: this.id || this.$route.params.id,
        show: true,
        title: "Orientações para o Supporter",
        description: "Job J",
        layout: "Orientation",
        job: this.job,
        cb: this.getJob
      };
      this.update();
    },
    openOrientationDefault() {
      this.modal = {
        id: this.id || this.$route.params.id,
        show: true,
        title: "Orientações para o Supporter",
        description: "Job J",
        layout: "OrientationDefault",
        job: this.job,
        cb: this.getJob
      };
      this.update();
    },
    openDeslocation() {
      this.buttonLoader = true;
      this.SET_DESLOCATION(this.id || this.$route.params.id)
        .then((r) => {
          if (r.status && (r.status == 201 || r.status == 200)) {
            this.modal = {
              id: this.id || this.$route.params.id,
              show: true,
              title: false,
              description: false,
              layout: "Deslocation",
            };
            this.job.status = "Doutor em trânsito";
          } else {
            // Recusado (por exemplo o 412 de job alterado por outra operação, sc-9896):
            // o aviso já foi mostrado pelo notify; recarrega o job para os botões
            // refletirem o estado atual.
            this.getJob();
          }
          this.buttonLoader = false;
        })
        .catch(() => (this.buttonLoader = false));
    },
    openCheckin() {
      this.buttonLoader = true;
      this.SET_CHECKIN(this.id || this.$route.params.id)
        .then((r) => {
          if (r.status && (r.status == 201 || r.status == 200)) {
            this.modal = {
              show: true,
              title: false,
              description: false,
              layout: "Checkin",
            };
            this.job.status = "Doutor no local";
          } else {
            this.getJob();
          }
          this.buttonLoader = false;
        })
        .catch(() => (this.buttonLoader = false));
    },
    openAttach() {
      this.modal = {
        id: this.id || this.$route.params.id,
        show: true,
        title: "Anexar arquivos",
        description: "Job J",
        layout: "Attach",
      };
      this.update();
    },
    openFinish() {
      this.modal = {
        id: this.id || this.$route.params.id,
        show: true,
        title: "Encerramento",
        description: "Job J",
        layout: "Finish",
        job: this.job,
        cb: this.getJob
      };
      this.update();
    },
    openAttendance() {
      this.modal = {
        id: this.id || this.$route.params.id,
        show: true,
        title: "Atendimentos",
        description: "Job J",
        layout: "Attendance",
      };
      this.update();
    },
  },
  beforeMount() {
    this.COMPLEMENTO_ESCOPO(this.id || this.$route.params.id).then(({ data }) => this.escopo = data)
    this.getJob();
  },
  computed: {
    ...mapGetters("user", ["user"]),
    campos_registro() {
      return (this.job.mapa_campos || []).filter(m => m.etapa == "registro" && this.job[m.nome])
    },
    campos_encerramento() {
      return (this.job.mapa_campos || []).filter(m => m.etapa == "encerramento" && this.job[m.nome])
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.job
  .t
    margin-right: 12px
    strong
      color: $purple
      margin-left: 5px
  .info 
    margin-top: 40px
    padding-bottom: 34px
    border-bottom: 1px solid $white-1
    .grid-6-s 
      @media (max-width: $small) 
        margin-bottom: 30px
  .adicionais
    background: rgba(#eee,.4)
    border-radius: 12px
    margin-right: 10px
    padding: 4px 14px
    @media (max-width: $small) 
        margin-bottom: 20px
   
</style>
<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.job {
  padding: 32px 35px;
  box-shadow: $shadow;
  background: $white;
  border-radius: 23px;

  @media (max-width: $small) {

    padding: 30px 20px
  }

  .note {
    margin-top: 15px;
  }

  .buttons {
    @media (max-width: $small) {
      margin-top: 27px;
      margin-bottom: 10px;
    }
  }

  .buttons-2 {
    padding-top: 35px;

    @media (max-width: $small) {
      margin-top: 27px;
      margin-bottom: 10px;

      button {
        margin-bottom: 20px;
      }
    }
  }

  &-loader {
    margin-top: 20%;
  }

  .title {
    font-size: 26px;
    font-weight: 400;

    @media (max-width: $large) {
      padding-bottom: 15px;
    }
  }

  .sla {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 30px;
  }

  .mt {
    margin-top: 26px;
  }

  .aggregate {
    margin-right: 15px;

    @media (max-width: $medium) {
      margin-bottom: 30px;

      select {
        margin-right: 15px;

        @media (max-width: $small) {
          margin-left: 25px;
        }
      }
    }
  }

  &-status {
    color: $white-7;
    font-size: 12px;
    list-style: none;

    li {
      margin-left: 40px;

      @media (max-width: $medium) {
        margin-left: 10px;
      }
    }

    .active {
      color: $green-9;
      border-bottom: 2px solid $green-9;
      height: 30px;
      font-weight: bold;
    }
  }

  .label {
    color: $purple;
    font-size: 15px;
    font-weight: 300;

    strong {
      color: $gray-7;
      text-transform: capitalize;
    }
  }

  .data {
    padding-top: 45px;
    padding-bottom: 46px;
    border-bottom: 1px solid $white-1;

    label {
      margin-bottom: 8px;
    }

    .grid-2-g {
      @media (max-width: $small) {
        margin-bottom: 30px;
      }
    }

    .ps {
      color: $gray-6;
      background: $white-8;
      padding: 8px 14px;
      border-radius: 5px;
      margin-left: 30px;
    }

    .row-2 {
      margin-top: 32px;
    }
  }

  .openmap {
    @media (max-width: $medium) and (min-width: $small) {
      margin-top: 38px;
    }

    @media (max-width: $small) {
      margin-top: 38px;
      justify-content: center;

      button {
        width: 100%;
      }
    }

    @media (min-width: $small) and (max-width: $large) {
      margin-top: 25px;
      justify-content: flex-end;
    }
  }

  .button-green-go,
  .button-blue-go,
  .button-red-go {
    @media (min-width: $small) {
      margin-left: 10.5px;
    }
  }

  .button-black-go {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 12px;

    i {
      margin-right: 6px;
      font-size: 20px;
      transform: rotate(90deg);
    }
  }

  @media (max-width: $small) {
    .button-gold-2 {
      margin-top: 10px;
    }
  }

  .vue-map-container {
    width: 100%;
    height: 330px;
  }

  .valid {
    background: $white-2;
    margin: 10px 0px;

    &,
    &-info {
      font-size: 13px;
      padding: 7px 5px;
    }
  }
}
</style>
